export const SET_BANK_ACCOUNT_TO_REMOVE = "SET_BANK_ACCOUNT_TO_REMOVE";
export const SET_OPEN_REMOVE_BANK_ACCT_MODAL = "SET_OPEN_REMOVE_BANK_ACCT_MODAL";
export const SET_OPEN_ADD_BANK_ACCT_MODAL = "SET_OPEN_ADD_BANK_ACCT_MODAL";
export const ACCOUNT_TYPES = ["Personal", "Business"];
